import { Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home';
import Navbar from './components/Navbar/Navbar'
import WebDevelopment from './components/CourseDetails/WebDevelopment';
import WebDevelopmentApply from './components/CourseDetails/WebDevelopment.apply';
import BlogOne from './components/Blog/BlogDetails/BlogOne';
import BlogTwo from './components/Blog/BlogDetails/BlogTwo';
import BlogThree from './components/Blog/BlogDetails/BlogThree';
import BlogFour from './components/Blog/BlogDetails/BlogFour';
import CoursesPage from './components/pages/Courses.page';
import DataAnalytics from './components/CourseDetails/DataAnalytics';
import DataAnalyticsApply from './components/CourseDetails/DataAnalytics.apply';
import MobileApp from './components/CourseDetails/MobileApp';
import MobileApply from './components/CourseDetails/MobileApp.apply';
import LearnMore from './components/LearnMore/LearnMore';
import NetworkEngineeering from './components/CourseDetails/NetworkEngineering';

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path='/' exact element={<Home/>} />
        <Route path='/sign-up' exact element={<Home/>} />
        <Route exact path='/course-list' element={<CoursesPage/>} />
        <Route path='/web-development' element={<WebDevelopment/>} />
        <Route path='/data-analytics' element={<DataAnalytics/>} />
        <Route path='/mobile-app-development' element={<MobileApp/>} />
        <Route path='/apply-now' element={<WebDevelopmentApply/>} />
        <Route path='/apply-data-analytics' element={<DataAnalyticsApply/>} />
        <Route path='/apply-mobile-app' element={<MobileApply/>} />
        <Route path='/color-psychology-in-graphic-design' element={<BlogOne/>} />
        <Route path='/essential-tools-every-web-developer-should-use' element={<BlogTwo/>} />
        <Route path='/unleashing-the-power-of-data' element={<BlogThree/>} />
        <Route path='/strategies-for-building-digital-campaign' element={<BlogFour/>} />
        <Route path='/network-engineering-bootcamp' element={<NetworkEngineeering/>} />
        <Route path='/learn-more' element={<LearnMore/>} />
      </Routes>
    </div>
  );
}

export default App;
